const REMOTE_CONFIG_COOKIE_NAME = "rc";
const PROD_TELEMETRY_URL = "https://telemetry.api.shapr3d.com/web";
const STAGE_TELEMETRY_URL = "https://stage.telemetry.api.shapr3d.com/web";
const localStorageKeys = {
    refreshToken: "token",
    accessToken: "accessToken",
};

export { PROD_TELEMETRY_URL, REMOTE_CONFIG_COOKIE_NAME, STAGE_TELEMETRY_URL, localStorageKeys };
//# sourceMappingURL=config.js.map
